import { axios } from "@/lib/axios";
import { ClassItem } from "@/features/Classes/types";

export const publishClass = (id: number): Promise<ClassItem> => {
    return axios.patch(`/api/admin/class/${id}/publish`);
}; 
